import config from '../config';
import selectedEnvironment from '../env';

const ROOT = `${config[selectedEnvironment].API_URL}/WhatsAppMessages`;

const getToken = () => {
  const token = localStorage.getItem('token');
  return token != null ? JSON.parse(token) : null;
};

const jsonHeaders = async () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${await getToken()}`,
});

/**
 * Send VAT / advances payment reminder to a client via WhatsApp (Twilio template).
 * @param {{ caseId: string, periodLabel: string, paymentLabel: string, amountFormatted: string }} payload
 */
const sendPaymentReminder = async (payload) => {
  const response = await fetch(`${ROOT}/send-payment-reminder`, {
    method: 'POST',
    headers: await jsonHeaders(),
    body: JSON.stringify({
      CaseId: payload.caseId,
      PeriodLabel: payload.periodLabel,
      PaymentLabel: payload.paymentLabel,
      AmountFormatted: payload.amountFormatted,
    }),
  });

  if (!response.ok) {
    const text = await response.text();
    let message = text;
    try {
      const parsed = JSON.parse(text);
      message = parsed.error ?? text;
    } catch {
      /* use raw text */
    }
    throw new Error(message || `HTTP ${response.status}`);
  }

  return response.json();
};

const sendDocumentsSubmissionInfo = async (caseId) => {
  const response = await fetch(`${ROOT}/send-documents-submission-info`, {
    method: 'POST',
    headers: await jsonHeaders(),
    body: JSON.stringify({ CaseId: caseId }),
  });

  if (!response.ok) {
    const text = await response.text();
    let message = text;
    try {
      const parsed = JSON.parse(text);
      message = parsed.error ?? text;
    } catch {
      /* use raw text */
    }
    throw new Error(message || `HTTP ${response.status}`);
  }

  return response.json();
};

const WhatsAppMessagesService = {
  sendPaymentReminder,
  sendDocumentsSubmissionInfo,
};

export default WhatsAppMessagesService;
